import React from 'react';
import { defaultTheme } from './../../styles/theme/default';
import { IIcon } from '../../@types/icons';

export function Delete ({ size= 16, onClick }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 12 12"
      onClick={onClick}
    >
      <path
        fill={defaultTheme.colors.oxfordBlue}
        fillRule="evenodd"
        d="M9.75 3h-7.5a.375.375 0 110-.75h7.5a.375.375 0 010 .75zm-.375 7.5a.75.75 0 01-.75.75h-5.25a.75.75 0 01-.75-.75V3.75h6.75v6.75zm-4.5-9.375c0-.207.168-.375.375-.375h1.5c.207 0 .375.168.375.375V1.5h-2.25v-.375zm5.25.375h-2.25V.75a.75.75 0 00-.75-.75h-2.25a.75.75 0 00-.75.75v.75h-2.25a.75.75 0 00-.75.75V3c0 .414.336.75.75.75v6.75a1.5 1.5 0 001.5 1.5h5.25a1.5 1.5 0 001.5-1.5V3.75a.75.75 0 00.75-.75v-.75a.75.75 0 00-.75-.75zM6 10.5a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.75 0v4.5c0 .207.168.375.375.375zm-1.875 0a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.75 0v4.5c0 .207.168.375.375.375zm3.75 0a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.75 0v4.5c0 .207.168.375.375.375z"
        clipRule="evenodd"
      />
    </svg>
  );
}
